import React from 'react';

const AddTodo = ({ todo, setTodo, allTodos, setAllTodos, setStatus }) => {
	const handleChange = (e) => {
		setTodo(e.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// console.log(todo);
		setAllTodos([
			...allTodos,
			{
				item: todo,
				completed: false,
				id: Math.floor(Math.random() * 10000),
			},
		]);
		setTodo('');
	};

	const statusHandler = (e) => {
		setStatus(e.target.value)
	};

	return (
		<div className='add-todo'>
			<form>
				<input type='text' onChange={handleChange} value={todo}></input>
				<button type='submit' onClick={handleSubmit}>
					<i onClick={handleSubmit} class='fas fa-plus-square fa-2x'></i>
				</button>
				
				<div onChange={statusHandler} className='select'>
					<select name='todos' class='filter-todo'>
						<option value='all'>All</option>
						<option value='completed'>Completed</option>
						<option value='incomplete'>Incomplete</option>
					</select>
				</div>
			</form>
		</div>
	);
};

export default AddTodo;
